import type { Account, IAccount } from '../me/access/organizations/accounts/account';

export interface IVariant {
	account: IAccount;
	enabled: boolean;
}

export class Variant implements IVariant {
	public account: Account;
	public enabled: boolean;
	public constructor({ account, enabled }: IVariant) {
		this.account = account;
		this.enabled = enabled;
	}
}
